<template>
  <v-card elevation="0" class="px-4" :height="heigth+'px'">

    <v-row>
      <v-col xl="8" lg="9" md="9" sm="10" cols="12" class="pa-0 ma-0 pl-3">
        <v-switch v-model="payment.particular" v-if="covenants.length > 0"
          label="Particular?" @change="changeParticular"/>

        <div v-else-if="patient != null">
          {{patient.name}}
          não possuí convênio. Busca por particular.
        </div>
      </v-col>
    </v-row>

   <v-row>
      <v-col xl="8" lg="9" md="9" sm="10" cols="12" v-if="!payment.particular" class="mb-5">
        <mb-autocomplete
          v-model="payment.covenant"
          :items="covenants"
          itemText="txt"
          returnObject
          name="covenant"
          label="Convênios"
          prependIcon="mdi-magnify"
          @input="$emit('input', payment)"
          hideDetails
        />
      </v-col>
    </v-row>

    <v-row class="mb-5" v-if="payment.particular">
      <v-col xl="8" lg="9" md="9" sm="10" cols="12">
        <v-subheader class="ma-0 pa-0 mb-7">
          Particular (Buscaremos valores nessa faixa. Ajuste caso desejar)
        </v-subheader>
        <v-range-slider class="ma-0 pa-0"
          v-model="valRange"
          thumb-label="always"
          min="0" max="4"
          :tick-labels="particularLabels"
          ticks="always" tick-size="5"
          @change="changeRange"
        >
        <template v-slot:thumb-label="props">
          <div>{{ getLabel(props.value) }}</div>
        </template>
        </v-range-slider>
      </v-col>
    </v-row>

    <v-container class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col xl="3" lg="3" md="3" sm="3" cols="12" class="pa-0 ma-0">
          <mb-text-button name="cf_pay_search" label="Procurar"
            icon="mdi-magnify"
            @click="$emit('finish')"
          />
        </v-col>

        <v-col xl="3" lg="3" md="3" sm="3" cols="12" class="pa-0 ma-0">
          <mb-text-button name="cf_pay_continue" label="Continuar"
            @click="$emit('click')"
            :primary="false"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import MbAutocomplete from '@/components/general/inputs/MbAutocomplete';
import MbTextButton from '@/components/general/buttons/MbTextButton';

export default {
  props: {
    value: {
      type: Object,
    },
    patient: {
      type: Object,
    },
  },
  data: () => ({
    covenantsLoading: false,
    covenants: [],
    payment: {
      particular: false,
      covenant: null,
      priceStart: null,
      priceEnd: null,
    },
    valRange: [0, 4],
    particularLabels: ['10', '100', '250', '500', '...'],
    particularValues: ['10', '100', '250', '500', null],
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    heigth() {
      let h = (this.$vuetify.breakpoint.xsOnly) ? 250 : 210;
      h = (this.payment.particular) ? h + 80 : h;
      return h;
    },
    isFecomercio() {
      return this.$store.getters['poweredBy/th'] === 'lnMQZ9bbUq';
    },
  },
  created() {
    this.getCovenants();
  },
  methods: {
    getLabel(val) {
      return this.particularLabels[val];
    },
    changeRange(val) {
      this.payment.priceStart = this.particularValues[val[0]];
      this.payment.priceEnd = this.particularValues[val[1]];
      this.$emit('input', this.payment);
    },
    getCovenants() {
      if (this.patient) {
        this.covenantsLoading = true;

        this.$store.dispatch('patientCovenants/all', { patientId: this.patient.id })
          .then((covenants) => {
            this.covenants = covenants.map((covenant) => {
              const cv = covenant;
              cv.txt = (this.isFecomercio) ? covenant.covenantName : `${covenant.cardNumber} - ${covenant.covenantName}`;
              return cv;
            });
            if (this.covenants.length > 0) {
              // eslint-disable-next-line prefer-destructuring
              this.payment.covenant = this.covenants[0];
            } else {
              this.payment.particular = true;
            }
            this.$emit('input', this.payment);
          })
          .finally(() => {
            this.covenantsLoading = false;
          });
      }
    },
    changeParticular() {
      if (this.payment.particular) {
        this.payment.covenant = null;
      } else if (this.covenants.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.payment.covenant = this.covenants[0];
      } else {
        this.payment.particular = true;
      }
      this.$emit('input', this.payment);
    },
  },
  watch: {
    patient() {
      this.getCovenants();
    },
  },
  components: {
    MbAutocomplete,
    MbTextButton,
  },
};
</script>
